import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/api-field/api-field'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...dependencies, ...props });
  };

  return {
    html,
  };
}
